const currencySigns = {
  'EUR': '€',
};

export const currency = {
  currencySign (value) {
    if (!value) {
      return value;
    }

    return currencySigns[value] || value;
  },
};
